import { STATE_RECORD } from "@/constants";
import {
  REFERRING_AGENCY_INITIAL_VALUES,
  ReferringAgencyFormValues,
} from "@/constants/referring-agency-constant";
import { Address, ReferringAgency } from "@/services";

const EMPTY_ADDRESS = REFERRING_AGENCY_INITIAL_VALUES.address;

const blankToUndefined = (value?: string) => value?.trim() || undefined;

const hasAddress = (address: Address) =>
  Object.values(address).some((value) => !!value?.trim());

export const toReferringAgencyFormValues = (
  agency: ReferringAgency
): ReferringAgencyFormValues => ({
  uuid: agency.uuid,
  agencyId: agency.agencyId ?? "",
  name: agency.name ?? "",
  agencyType: agency.agencyType ?? "",
  npi: agency.npi ?? "",
  contactPerson: agency.contactPerson ?? "",
  contactRole: agency.contactRole ?? "",
  phone: agency.phone ?? "",
  email: agency.email ?? "",
  fax: agency.fax ?? "",
  address: {
    line1: agency.address?.line1 ?? EMPTY_ADDRESS.line1,
    line2: agency.address?.line2 ?? EMPTY_ADDRESS.line2,
    city: agency.address?.city ?? EMPTY_ADDRESS.city,
    state: agency.address?.state ?? EMPTY_ADDRESS.state,
    country: agency.address?.country ?? EMPTY_ADDRESS.country,
    zipcode: agency.address?.zipcode ?? EMPTY_ADDRESS.zipcode,
  },
  archive: agency.archive,
});

export const toReferringAgencyPayload = (
  values: ReferringAgencyFormValues
): ReferringAgency => ({
  ...values,
  agencyId: values.agencyId.trim(),
  name: values.name.trim(),
  agencyType: values.agencyType.trim(),
  contactPerson: values.contactPerson.trim(),
  contactRole: values.contactRole.trim(),
  npi: blankToUndefined(values.npi),
  email: blankToUndefined(values.email),
  fax: blankToUndefined(values.fax),
  address: hasAddress(values.address) ? values.address : undefined,
});

export const formatReferringAgencyAddress = (agency: ReferringAgency) =>
  [
    agency.address?.city,
    STATE_RECORD[agency.address?.state as keyof typeof STATE_RECORD],
    agency.address?.zipcode,
  ]
    .filter(Boolean)
    .join(", ") || "-";

export const toReferringAgencyRefs = (
  agencies?: Pick<ReferringAgency, "uuid">[]
): Pick<ReferringAgency, "uuid">[] =>
  (agencies ?? []).map(({ uuid }) => ({ uuid }));

export const formatReferringAgencyLabel = (agency: ReferringAgency) =>
  agency.agencyId ? `${agency.name} (${agency.agencyId})` : (agency.name ?? "");
